module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 45
// module chunks = 0